import React from "react";

const SignUpPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <h1>Sign Un</h1>
    </div>
  );
};

export default SignUpPage;
